<template>
  <svg viewBox="0 0 1024 1024" fill="currentColor">
    <path
      d="M489.6 582.4c-3.2 0-9.6 0-12.8-3.2L32 400c-12.8-6.4-19.2-16-19.2-28.8s6.4-25.6 19.2-28.8l448-179.2c6.4-3.2 16-3.2 22.4 0l448 179.2c12.8 6.4 19.2 16 19.2 28.8s-6.4 25.6-19.2 28.8l-448 179.2c-3.2 3.2-6.4 3.2-12.8 3.2zM128 371.2l361.6 144 361.6-144-361.6-144L128 371.2z"
    />
    <path
      d="M940.8 601.6c-19.2 0-32-12.8-32-32v-195.2c0-19.2 12.8-32 32-32s32 12.8 32 32v195.2c0 19.2-16 32-32 32zM489.6 864c-153.6 0-262.4-105.6-265.6-108.8-6.4-6.4-9.6-12.8-9.6-22.4v-265.6c0-19.2 12.8-32 32-32s32 12.8 32 32v249.6c25.6 22.4 108.8 83.2 211.2 83.2 102.4 0 185.6-60.8 211.2-83.2v-249.6c0-19.2 12.8-32 32-32s32 12.8 32 32v265.6c0 9.6-3.2 16-9.6 22.4 0 3.2-112 108.8-265.6 108.8z"
    />
  </svg>
</template>
